var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.49967 10.4997C4.46617 10.4997 5.24967 9.71617 5.24967 8.74967C5.24967 7.78318 4.46617 6.99967 3.49967 6.99967C2.53318 6.99967 1.74967 7.78318 1.74967 8.74967C1.74967 9.71617 2.53318 10.4997 3.49967 10.4997ZM3.49967 11.6663C5.1105 11.6663 6.41634 10.3605 6.41634 8.74967C6.41634 7.13884 5.1105 5.83301 3.49967 5.83301C1.88884 5.83301 0.583008 7.13884 0.583008 8.74967C0.583008 10.3605 1.88884 11.6663 3.49967 11.6663Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50033 10.5C3.82249 10.5 4.08366 10.7612 4.08366 11.0833V12.8333C4.08366 13.1555 3.82249 13.4167 3.50033 13.4167C3.17816 13.4167 2.91699 13.1555 2.91699 12.8333V11.0833C2.91699 10.7612 3.17816 10.5 3.50033 10.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50033 0.583008C3.82249 0.583008 4.08366 0.844175 4.08366 1.16634L4.08366 6.41634C4.08366 6.73851 3.82249 6.99967 3.50033 6.99967C3.17816 6.99967 2.91699 6.73851 2.91699 6.41634L2.91699 1.16634C2.91699 0.844175 3.17816 0.583008 3.50033 0.583008Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4997 6.99967C11.4662 6.99967 12.2497 6.21617 12.2497 5.24967C12.2497 4.28318 11.4662 3.49967 10.4997 3.49967C9.53318 3.49967 8.74967 4.28318 8.74967 5.24967C8.74967 6.21617 9.53318 6.99967 10.4997 6.99967ZM10.4997 8.16634C12.1105 8.16634 13.4163 6.86051 13.4163 5.24967C13.4163 3.63884 12.1105 2.33301 10.4997 2.33301C8.88884 2.33301 7.58301 3.63884 7.58301 5.24967C7.58301 6.86051 8.88884 8.16634 10.4997 8.16634Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5003 7C10.8225 7 11.0837 7.26117 11.0837 7.58333L11.0837 12.8333C11.0837 13.1555 10.8225 13.4167 10.5003 13.4167C10.1782 13.4167 9.91699 13.1555 9.91699 12.8333L9.91699 7.58333C9.91699 7.26117 10.1782 7 10.5003 7Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5003 0.583008C10.8225 0.583008 11.0837 0.844175 11.0837 1.16634V2.91634C11.0837 3.23851 10.8225 3.49967 10.5003 3.49967C10.1782 3.49967 9.91699 3.23851 9.91699 2.91634V1.16634C9.91699 0.844175 10.1782 0.583008 10.5003 0.583008Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.90eadf8f00f2965948221cf038225f11.svg";
export { ForwardRef as ReactComponent };